export default __webpack_public_path__ + "static/media/star.75ff2ffa.svg";